import request from '@/router/axios';

/** 分页列表 GET /blade-desk/notification/page */
export const getNotificationPage = (params) => {
  return request({
    url: '/api/blade-desk/notification/page',
    method: 'get',
    params: {
      msgType: 'all',
      current: 1,
      size: 10,
      ...params,
    },
  });
};

/** 未读数量 GET /blade-desk/notification/unread-count */
export const getUnreadCount = (params) => {
  return request({
    url: '/api/blade-desk/notification/unread-count',
    method: 'get',
    params: {
      msgType: 'all',
      ...params,
    },
  });
};

/** 单条已读 POST /blade-desk/notification/read-one */
export const readOne = (id) => {
  return request({
    url: '/api/blade-desk/notification/read-one',
    method: 'post',
    params: { id },
  });
};

/** 批量已读 POST /blade-desk/notification/read-batch */
export const readBatch = (ids) => {
  return request({
    url: '/api/blade-desk/notification/read-batch',
    method: 'post',
    params: { ids },
  });
};

/** 全部已读 POST /blade-desk/notification/read-all */
export const readAll = (msgType) => {
  return request({
    url: '/api/blade-desk/notification/read-all',
    method: 'post',
    params: { msgType: msgType != null ? msgType : 'all' },
  });
};

/** 批量删除 POST /blade-desk/notification/remove */
export const removeBatch = (ids) => {
  return request({
    url: '/api/blade-desk/notification/remove',
    method: 'post',
    params: { ids },
  });
};
